import { defaultDate } from '@/datas/DateFormats'
import { Message } from 'element-ui'
import { getFuturePeriod, getNow, isAfterDay } from './date'

export const getShortFio = fio => {
  if (fio) {
    const arr = fio.split(' ')
    let short = `${arr[0]} `

    for (let i = 1; i < arr.length; i++) {
      short += `${arr[i][0]}.`
    }

    return short
  }

  return 'Незамутдинов К.А.'
}

export const getPoints = (load_point, unload_point) => {
  const points = {
    load: { top: '', bottom: '' },
    unload: { top: '', bottom: '' },
  }
  const cutCity = text => text.replace('Город ', '')

  if (load_point) {
    const arr = load_point.split(',')

    points.load.bottom = arr[0]
    const len = arr.length

    if (len > 1) {
      points.load.top = cutCity(arr[len - 1])
    }
  }
  if (unload_point) {
    const arr = unload_point.split(',')

    points.unload.bottom = arr[0]
    const len = arr.length

    if (len > 1) {
      points.unload.top = cutCity(arr[len - 1])
    }
  }

  return points
}

export const preparePhone = phone => (phone ? phone.replace(/\D/g, '') : '')

export const dateToFilter = param => {
  let date

  if (param === 'today') {
    date = getNow(defaultDate)
  } else if (param === 'tomorrow') {
    date = getFuturePeriod(defaultDate, 1)
  } else {
    date = param
  }

  return date
}

export const kitcutText = (text, limit) => {
  text = text.trim()

  if (text.length <= limit) {
    return text
  }

  text = text.slice(0, limit)

  return text.trim() + '...'
}

export const checkDate = day => {
  let date = day ? prepareDate(day) : ''
  const now = getNow(defaultDate)
  const tomorrow = getFuturePeriod(defaultDate, 1)

  if (date && now === day) {
    date = 'сегодня'
  } else if (date && tomorrow === day) {
    date = 'завтра'
  }

  return date
}

export const prepareDate = (date, sepFrom = '-', sepTo = '-') => {
  if (date === 'сегодня') {
    return getNow(defaultDate)
  }
  if (date === 'завтра') {
    return getFuturePeriod(defaultDate, 1)
  }

  return date ? date.split(sepFrom).reverse().join(sepTo) : ''
}

export const arrToObj = (arr = [], field = '') => {
  const obj = {}

  arr.map(i => (obj[i.id] = field ? i[field] : i))

  return obj
}

export const roundUp = (num, digit = 100) =>
  num ? Math.round(num * digit) / digit : 0

export const isFutures = (date, flag = false) => {
  if (!date) {
    return false
  }
  if (['сегодня', 'завтра'].includes(date)) {
    return true
  }

  const currentDay = getNow(defaultDate)
  const afterDateMoment = isAfterDay(currentDay)

  if (flag) {
    date = prepareDate(date)
  }

  return afterDateMoment(date)
}

export const checkAutocomplite = (flag, point, kladr_id, updated) => {
  let id, name, relation, clear

  if (kladr_id && !updated) {
    const regId = kladr_id[0] + kladr_id[1] + '00000000000'

    id = flag ? kladr_id : regId
    name = point ? point.split(',')[flag] : ''

    if (flag) {
      relation = regId
    }
  } else if (flag && updated && !kladr_id) {
    clear = true
  }

  return { id, name, relation, clear }
}

export const capital_letter = str => {
  if (str) {
    str = str.split(' ')

    for (let i = 0, x = str.length; i < x; i++) {
      if (str[i] && str[i][0]) {
        str[i] = str[i][0].toUpperCase() + str[i].substr(1)
      }
    }
  }

  return str ? str.join(' ') : str
}

export const validateNumber = n =>
  !isNaN(parseFloat(n)) &&
  isFinite(n) &&
  Number.isInteger(parseFloat(n)) &&
  parseFloat(n) > 0

export const getFilterStatus = value => {
  switch (value) {
    case '0':
      return 'waiting'
    case '1':
      return 'approved'
    case '2':
      return 'denied'
    default:
      return ''
  }
}

export const toChunks = (arr, size) =>
  Array.from({ length: Math.ceil(arr.length / size) }, (v, i) =>
    arr.slice(i * size, i * size + size),
  )

export const pluralNew = (num, forms) => {
  if (!forms) {
    const type = num % 30 === 0 ? 'm' : 'd'

    if (type === 'm') {
      num /= 30
    }
    forms = periodTypes[type].split('_')
  }
  let text = forms[2]

  if (num % 10 === 1 && num % 100 !== 11) {
    text = forms[0]
  }
  if (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)) {
    text = forms[1]
  }

  return `${num} ${text}`
}

const periodTypes = {
  d: 'день_дня_дней',
  m: 'месяц_месяца_месяцев',
}

let timeout

export const debounce = (fn, wait = 500) => {
  if (timeout) {
    clearTimeout(timeout)
  }

  timeout = setTimeout(() => {
    fn()
    clearTimeout(timeout)
  }, wait)
}

export const formattedNumberDecimal = number =>
  Intl.NumberFormat('ru-RU', { minimumFractionDigits: 2 })
    .format(Number(number).toFixed(2))
    .replace(',', '.')

export const showErrorMessage = err => {
  Message.error(err?.response?.data[0]?.message)

  return err?.response ? err?.response?.data[0]?.message : 'Ошибка!'
}

export const formattedNumberInteger = number =>
  Intl.NumberFormat('ru-RU').format(Number(number.toFixed(0)))
